import styled from 'styled-components'
import { Box } from '@mui/material'

export const LegendItem = styled(Box)`
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 20px;
  padding: 8px;
  border-radius: 4px;
`

export const LegendIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`
